class SquamaItem extends HTMLElement {
    constructor() {
        super();

        this.reinit();
        this.addEventListener("focusin", () =>
            this.setAttribute("data-focused", "")
        );
        this.addEventListener("focusout", () => {
            this.removeAttribute("data-focused");
            this.scrollTop = 0;
        });
    }

    reinit(isForce) {
        if (
            !isForce && // check if reinit not forced
            // element already inited on this width
            this.initializedOnWidth === window.innerWidth
        ) {
            // skip reinit
            return;
        }

        this.uninit();
        setTimeout(() => {
            // Set height for squama item on screens greater 767px.
            // Other wise set heigh 'auto'.
            this.style.height =
                window.visualViewport.width > 767
                    ? this.clientHeight + "px"
                    : "auto";
            this.setAttribute("data-status", "ready");
            this.initializedOnWidth = window.innerWidth;
        }, 100);
    }

    uninit() {
        this.removeAttribute("data-status");
        this.style.height = "auto";
    }
}

customElements.define("squama-item", SquamaItem);

/* Listen window resize and trigger squama items height update */
window.addEventListener(
    "resize",
    debounce(() => {
        document
            .querySelectorAll("squama-item")
            .forEach((item) => item.reinit());
    }, 200)
);
